













import { Vue, Component } from 'vue-property-decorator';
import Brand from '@/services/Brand';
import { getPublicSettings } from '@/services/Settings';

@Component({
	name: 'LiveChatToggle',
})
export default class LiveChatToggle extends Vue {
	private active: boolean = false;
	private moveUp: boolean = false;
	private helpMessage: boolean = false;

	private async created() {
		try {
			const getLiveChatStatus = await getPublicSettings(['liveChatStatus']);
			this.active = getLiveChatStatus.data.find(
				s => s.setting_key === 'liveChatStatus',
			).active;
		} catch (e) {
			console.log(e);
		}

		setInterval(this.checkForCookieBanner, 100);
		setTimeout(() => {
			this.helpMessage = true;
		}, 5000);
	}

	private checkForCookieBanner() {
		const banner = document.querySelector('.optanon-alert-box-wrapper');

		// @ts-ignore
		if (banner?.style.display === 'none') {
			this.moveUp = false;
		} else {
			this.moveUp = true;
		}
	}

	private openChat() {
		/**
		 * We need to open the chat in a new window so we can make sure we stay connected with the user if they refresh the page.
		 */
		try {
			const liveChatWindow = window.open(
				'/livechat',
				Brand.getProperBrand() + ' Live Chat',
				'width=350,height=580',
			);
		} catch (e) {
			console.log(e);
		}
	}
}
